var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSugarGliderAfraid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_177307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.5 317.001C218.318 317.001 266 310.443 266 302.353C266 294.264 218.318 287.706 159.5 287.706C100.682 287.706 53 294.264 53 302.353C53 310.443 100.682 317.001 159.5 317.001Z",
    fill: "#EDB27C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.719 279.216L124.978 277.961L159.559 243.704V158.869H106.039L94.5322 134.119L91.9551 128.559C47.5451 230.491 123.719 279.216 123.719 279.216Z",
    fill: "url(#paint0_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.719 279.216L124.978 277.961C61.5693 227.741 83.2649 157.614 94.5322 134.059L91.9551 128.559C47.5451 230.491 123.719 279.216 123.719 279.216Z",
    fill: "url(#paint1_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.277 279.216L194.019 277.96L159.438 243.704V158.869H213.017L224.524 134.118L227.101 128.618C271.511 230.491 195.277 279.216 195.277 279.216Z",
    fill: "url(#paint2_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.278 279.216L194.02 277.961C257.428 227.741 235.733 157.614 224.465 134.059L227.042 128.559C271.512 230.491 195.278 279.216 195.278 279.216Z",
    fill: "url(#paint3_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.848 255.302C257.369 254.345 256.71 253.389 255.871 252.612C255.032 251.834 254.073 251.117 252.994 250.579C251.915 250.041 250.716 249.682 249.398 249.443C249.398 249.443 243.525 247.769 232.257 253.688C227.103 256.378 221.469 258.172 215.656 258.53C209.003 258.949 200.613 258.052 191.923 253.269L189.705 251.894L188.866 254.166L187.368 256.259C186.888 256.856 186.469 257.394 185.929 257.933C185.45 258.471 184.911 259.009 184.191 259.666C184.911 260.503 185.63 261.28 186.409 262.058C187.188 262.835 187.967 263.552 188.806 264.33C189.645 265.047 190.544 265.764 191.443 266.482C192.342 267.199 193.301 267.857 194.32 268.514C195.279 269.172 196.358 269.77 197.377 270.368C198.455 270.966 199.534 271.563 200.673 272.102C201.812 272.64 202.95 273.118 204.149 273.596C205.168 274.015 206.247 274.373 207.325 274.732C208.404 275.091 209.483 275.39 210.562 275.689C211.64 275.988 212.779 276.227 213.918 276.466C215.057 276.705 216.195 276.884 217.334 277.064C218.473 277.243 219.611 277.363 220.81 277.482C221.949 277.602 223.148 277.661 224.286 277.721C225.425 277.781 226.624 277.781 227.762 277.781C228.901 277.781 230.04 277.721 231.178 277.661C232.437 277.602 233.696 277.482 234.954 277.303C236.213 277.123 237.411 276.944 238.67 276.705C239.869 276.466 241.067 276.167 242.206 275.868C243.345 275.569 244.424 275.21 245.502 274.792C246.581 274.373 247.6 273.955 248.559 273.477C249.518 272.998 250.417 272.46 251.256 271.922C252.275 271.265 253.234 270.547 254.073 269.77C254.912 268.993 255.631 268.156 256.29 267.319C256.89 266.422 257.429 265.525 257.848 264.569C258.268 263.612 258.508 262.656 258.687 261.639C258.867 260.623 258.867 259.607 258.747 258.53C258.687 257.275 258.328 256.259 257.848 255.302Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.929 252.552C255.09 251.775 254.131 251.057 253.052 250.519C251.974 249.981 250.775 249.623 249.456 249.383C249.456 249.383 243.943 247.829 233.395 253.09C236.691 254.346 240.826 256.737 242.924 260.862C243.164 261.34 242.624 261.819 242.205 261.52L239.747 260.025C239.747 260.025 245.681 265.585 243.523 275.33C244.242 275.091 244.961 274.852 245.621 274.613C246.7 274.194 247.718 273.776 248.677 273.297C249.636 272.819 250.535 272.281 251.374 271.743C252.393 271.085 253.352 270.368 254.191 269.591C255.03 268.813 255.749 267.976 256.409 267.139C257.008 266.243 257.547 265.346 257.967 264.389C258.386 263.433 258.626 262.476 258.806 261.46C258.986 260.444 258.986 259.427 258.866 258.351C258.746 257.275 258.446 256.259 257.907 255.302C257.368 254.286 256.708 253.389 255.929 252.552Z",
    fill: "#332D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.847 255.302C257.368 254.345 256.708 253.389 255.869 252.611C255.09 251.834 254.191 251.177 253.172 250.698C253.292 250.818 253.472 250.937 253.592 251.057C254.371 251.834 255.03 252.791 255.51 253.747C255.989 254.704 256.289 255.78 256.409 256.796C256.529 257.872 256.529 258.889 256.349 259.905C256.229 260.921 255.929 261.878 255.57 262.835C255.21 263.791 254.671 264.688 254.071 265.525C253.472 266.362 252.753 267.199 251.914 267.976C251.075 268.753 250.176 269.471 249.157 270.128C248.318 270.666 247.419 271.204 246.46 271.683C245.501 272.161 244.542 272.579 243.463 272.998C242.444 273.416 241.366 273.775 240.227 274.074C239.088 274.373 237.949 274.672 236.751 274.911C235.552 275.15 234.354 275.33 233.155 275.509C231.956 275.688 230.698 275.748 229.439 275.868C228.3 275.927 227.222 275.987 226.083 275.987C224.944 275.987 223.805 275.987 222.667 275.927C221.528 275.868 220.389 275.808 219.251 275.688C218.112 275.569 216.973 275.449 215.834 275.27C214.696 275.09 213.557 274.911 212.478 274.672C211.399 274.433 210.261 274.194 209.182 273.895C208.103 273.596 207.024 273.297 205.946 272.938C204.867 272.579 203.848 272.221 202.829 271.802C201.69 271.324 200.552 270.846 199.413 270.308C198.334 269.77 197.255 269.172 196.177 268.574C195.158 267.976 194.139 267.318 193.18 266.721C192.221 266.063 191.262 265.405 190.363 264.688C189.464 263.97 188.625 263.253 187.786 262.536C186.947 261.818 186.168 261.041 185.389 260.264C185.089 259.965 184.849 259.666 184.55 259.367C184.43 259.487 184.37 259.546 184.25 259.666C184.969 260.503 185.688 261.28 186.467 262.057C187.247 262.835 188.026 263.552 188.865 264.329C189.704 265.047 190.603 265.764 191.502 266.481C192.401 267.199 193.36 267.856 194.379 268.514C195.338 269.172 196.416 269.77 197.435 270.367C198.514 270.965 199.593 271.563 200.731 272.101C201.87 272.639 203.009 273.118 204.208 273.596C205.226 274.014 206.305 274.373 207.384 274.732C208.463 275.09 209.542 275.389 210.62 275.688C211.699 275.987 212.838 276.226 213.977 276.465C215.115 276.705 216.254 276.884 217.393 277.063C218.531 277.243 219.67 277.362 220.869 277.482C222.007 277.601 223.206 277.661 224.345 277.721C225.484 277.781 226.682 277.781 227.821 277.781C228.96 277.781 230.098 277.721 231.237 277.661C232.496 277.601 233.754 277.482 235.013 277.302C236.271 277.123 237.47 276.944 238.729 276.705C239.927 276.465 241.126 276.167 242.265 275.868C243.403 275.569 244.482 275.21 245.561 274.791C246.64 274.373 247.659 273.954 248.617 273.476C249.576 272.998 250.475 272.46 251.314 271.922C252.333 271.264 253.292 270.547 254.131 269.77C254.97 268.992 255.689 268.155 256.349 267.318C256.948 266.422 257.487 265.525 257.907 264.568C258.327 263.612 258.566 262.655 258.746 261.639C258.926 260.623 258.926 259.606 258.806 258.53C258.686 257.275 258.327 256.258 257.847 255.302Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.658 293.684C106.1 287.945 113.112 282.205 123.6 279.156H136.905C134.448 291.412 120.124 300.739 111.673 297.869C109.756 297.211 108.197 295.657 107.658 293.684Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.045 279.216C131.449 290.276 118.324 298.347 110.413 295.657C109.334 295.298 108.435 294.64 107.656 293.803C108.196 295.716 109.754 297.271 111.672 297.928C120.182 300.858 134.506 291.472 136.903 279.216H135.045Z",
    fill: "#334E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.218 229.774C214.218 229.236 214.158 228.638 214.158 228.1C214.038 225.948 213.858 223.795 213.559 221.643C213.499 221.105 213.439 220.567 213.319 219.969C213.259 219.431 213.139 218.893 213.079 218.355C213.019 217.817 212.899 217.279 212.84 216.741C212.72 216.203 212.66 215.665 212.54 215.186C212.42 214.648 212.3 214.11 212.24 213.512C212.12 212.974 212.001 212.436 211.881 211.898C211.761 211.36 211.641 210.822 211.521 210.284C211.341 209.626 211.221 208.909 211.042 208.251C210.982 207.833 210.862 207.474 210.802 207.056C204.149 180.152 190.485 154.864 192.343 137.646H159.5H126.657C128.515 154.864 114.85 180.093 108.197 207.056C108.138 207.474 108.018 207.833 107.958 208.251C107.778 208.909 107.658 209.626 107.478 210.284C107.358 210.822 107.239 211.36 107.119 211.898C106.999 212.436 106.879 212.974 106.759 213.512C106.639 214.05 106.519 214.588 106.459 215.186C106.34 215.724 106.28 216.262 106.16 216.741C106.04 217.279 105.98 217.817 105.92 218.355C105.86 218.893 105.74 219.431 105.68 219.969C105.62 220.507 105.501 221.045 105.441 221.643C105.141 223.795 104.961 225.948 104.841 228.1C104.781 228.638 104.781 229.236 104.781 229.774C104.122 246.812 108.557 263.791 123.6 279.216H136.905C137.085 266.482 145.296 258.71 159.5 258.65C173.704 258.65 181.914 266.482 182.094 279.216H195.399C210.382 263.791 214.877 246.753 214.218 229.774Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M214.218 229.774C214.218 229.236 214.158 228.638 214.158 228.1C214.038 225.948 213.858 223.795 213.559 221.643C213.499 221.105 213.439 220.567 213.319 219.969C213.259 219.431 213.139 218.893 213.079 218.355C213.019 217.817 212.9 217.279 212.84 216.741C212.72 216.203 212.66 215.665 212.54 215.186C212.42 214.648 212.3 214.11 212.24 213.512C212.12 212.974 212.001 212.436 211.881 211.898C211.761 211.36 211.641 210.822 211.521 210.284C211.341 209.626 211.221 208.909 211.042 208.251C210.982 207.833 210.862 207.474 210.802 207.056C204.149 180.152 190.485 154.864 192.343 137.646H188.147C187.009 155.162 200.194 180.272 206.726 206.996C206.786 207.414 206.906 207.773 206.966 208.191C207.146 208.909 207.266 209.567 207.446 210.284C207.566 210.822 207.685 211.36 207.805 211.898C207.925 212.436 208.045 212.974 208.165 213.512C208.285 214.05 208.405 214.648 208.465 215.186C208.584 215.724 208.644 216.262 208.764 216.8C208.884 217.339 208.944 217.877 209.004 218.415C209.064 218.953 209.184 219.491 209.244 220.089C209.304 220.627 209.423 221.225 209.483 221.763C209.783 223.975 209.963 226.127 210.083 228.339C210.143 228.877 210.143 229.475 210.143 230.013C210.802 246.872 206.607 263.731 192.522 279.096H195.459C210.382 263.791 214.877 246.753 214.218 229.774Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.601 279.215H126.538C112.454 263.851 108.258 246.991 108.918 230.132C108.918 229.594 108.978 228.996 108.978 228.458C109.097 226.246 109.277 224.094 109.577 221.882C109.637 221.344 109.697 220.746 109.817 220.208C109.877 219.67 109.996 219.132 110.056 218.534C110.116 217.996 110.236 217.458 110.296 216.92C110.416 216.382 110.476 215.843 110.596 215.305C110.716 214.767 110.836 214.169 110.895 213.631C111.015 213.093 111.135 212.555 111.255 212.017C111.375 211.479 111.495 210.941 111.615 210.403C111.794 209.686 111.914 209.028 112.094 208.311C112.154 207.892 112.274 207.533 112.334 207.115C118.866 180.331 131.992 155.222 130.913 137.765H126.718C128.576 154.983 114.911 180.212 108.258 207.175C108.199 207.593 108.079 207.952 108.019 208.37C107.839 209.028 107.719 209.745 107.539 210.403C107.419 210.941 107.3 211.479 107.18 212.017C107.06 212.555 106.94 213.093 106.82 213.631C106.7 214.169 106.58 214.708 106.52 215.305C106.401 215.843 106.341 216.382 106.221 216.86C106.101 217.398 106.041 217.936 105.981 218.474C105.921 219.012 105.801 219.55 105.741 220.088C105.681 220.626 105.561 221.164 105.502 221.762C105.202 223.914 105.022 226.067 104.902 228.219C104.842 228.757 104.842 229.355 104.842 229.893C104.123 246.752 108.618 263.791 123.601 279.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.341 293.684C212.899 287.945 205.887 282.205 195.399 279.156H182.094C184.551 291.412 198.875 300.739 207.325 297.869C209.243 297.211 210.801 295.657 211.341 293.684Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.952 279.216C187.548 290.276 200.673 298.347 208.584 295.657C209.663 295.298 210.562 294.64 211.341 293.803C210.801 295.716 209.243 297.271 207.325 297.928C198.815 300.858 184.491 291.472 182.094 279.216H183.952Z",
    fill: "#334E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.54 204.843C193.361 175.369 180.415 160.543 180.954 137.705H159.499H138.043C138.582 160.483 125.697 175.369 125.457 204.843C125.457 205.142 125.457 205.381 125.457 205.68C125.457 223.257 140.68 237.546 159.499 237.546C178.317 237.546 193.54 223.257 193.54 205.68C193.54 205.381 193.54 205.142 193.54 204.843Z",
    fill: "url(#paint4_radial_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.552 60.7629L214.698 55.5616L201.692 41.6318L189.586 28.5987C199.834 7.37512 223.568 0.739022 231.838 10.2448C243.465 23.517 234.955 50.1212 219.552 60.7629Z",
    fill: "url(#paint5_radial_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.699 55.5615L201.694 41.6317C202.653 41.9904 203.552 42.4089 204.451 42.8274C205.349 43.2459 206.368 43.784 207.267 43.0665C207.747 42.7078 207.987 42.0502 207.927 41.3926C207.807 40.0773 206.788 39.1805 205.769 38.4033L209.545 37.9848C210.504 37.8653 210.983 36.6696 210.324 35.9522C209.545 35.175 208.586 34.5771 207.507 34.2184C205.769 33.6206 203.911 33.6206 202.113 33.6206C203.731 33.0825 205.409 32.5444 207.088 32.0064C207.567 31.827 208.046 31.6477 208.286 31.2292C208.526 30.7509 208.226 30.0933 207.807 29.7345C207.327 29.3758 206.728 29.3161 206.189 29.2563C204.211 29.0769 202.173 29.1367 200.195 29.4954C207.867 17.3591 220.812 10.0654 226.745 14.7286C236.215 24.7724 223.869 48.5069 214.699 55.5615Z",
    fill: "url(#paint6_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.717 40.6155C227.762 49.3441 221.708 56.2193 207.265 42.1699C199.234 34.3381 190.544 28.7183 189.764 28.2999C189.704 28.4194 189.645 28.4792 189.645 28.539L201.751 41.5721L214.756 55.5019L219.611 60.7032C234.294 50.5995 242.685 25.9683 233.455 12.2178C237.231 20.7072 235.133 33.0826 231.717 40.6155Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5087 60.7629L104.363 55.5616L117.369 41.6318L129.475 28.5987C119.227 7.37512 95.4933 0.739022 87.2226 10.2448C75.5957 23.517 84.1061 50.1212 99.5087 60.7629Z",
    fill: "url(#paint7_radial_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.365 55.5615L117.371 41.6317C116.412 41.9904 115.513 42.4089 114.614 42.8274C113.715 43.2459 112.696 43.784 111.797 43.0665C111.317 42.7078 111.078 42.0502 111.138 41.3926C111.258 40.0773 112.276 39.1805 113.295 38.4033L109.52 37.9848C108.561 37.8653 108.081 36.6696 108.74 35.9522C109.52 35.175 110.478 34.5771 111.557 34.2184C113.295 33.6206 115.153 33.6206 116.951 33.6206C115.333 33.0825 113.655 32.5444 111.977 32.0064C111.497 31.827 111.018 31.6477 110.778 31.2292C110.538 30.7509 110.838 30.0933 111.258 29.7345C111.737 29.3758 112.336 29.3161 112.876 29.2563C114.853 29.0769 116.891 29.1367 118.869 29.4954C111.138 17.3591 98.2522 10.0654 92.3189 14.7286C82.7896 24.7724 95.1956 48.5069 104.365 55.5615Z",
    fill: "url(#paint8_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3433 40.6155C91.2989 49.3441 97.352 56.2193 111.796 42.1699C119.827 34.3381 128.517 28.7183 129.296 28.2999C129.356 28.4194 129.416 28.4792 129.416 28.539L117.31 41.5721L104.364 55.5617L99.5096 60.7629C84.8262 50.6593 76.4356 26.028 85.6652 12.2178C81.8295 20.7072 83.9272 33.0826 87.3433 40.6155Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.765 66.9806C208.167 44.4417 191.925 19.5713 160.041 19.5713C159.861 19.5713 159.681 19.5713 159.502 19.5713C159.322 19.5713 159.142 19.5713 158.962 19.5713C127.078 19.5713 110.896 44.4417 91.2385 66.9806C70.1423 92.2097 86.6837 116.243 93.9355 123.118C111.076 139.38 136.008 148.467 159.562 148.527C183.115 148.467 207.987 139.32 225.188 123.118C232.379 116.303 248.861 92.2695 227.765 66.9806Z",
    fill: "url(#paint9_radial_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.012 90.4756C238.012 90.8343 238.072 91.2528 238.072 91.6115C238.072 91.2528 238.072 90.8941 238.012 90.4756Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.773 88.2041C237.833 88.8617 237.953 89.5194 238.013 90.1172C237.953 89.4596 237.893 88.8019 237.773 88.2041Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.908 125.151C222.728 125.331 222.488 125.51 222.309 125.63C222.488 125.45 222.728 125.331 222.908 125.151Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.012 90.2368C238.012 90.177 238.012 90.1172 238.012 90.1172C238.012 90.2368 238.012 90.3563 238.072 90.5357C238.012 90.4161 238.012 90.3563 238.012 90.2368Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.771 88.0243C237.771 87.9645 237.771 87.8449 237.711 87.7852C237.711 87.9047 237.771 88.0841 237.771 88.2036C237.771 88.1439 237.771 88.0841 237.771 88.0243Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.132 91.7309C238.132 91.6711 238.132 91.6711 238.132 91.6113C238.072 91.6711 238.132 91.7309 238.132 91.7309Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.654 87.2472C237.654 87.1276 237.594 87.0678 237.594 86.9482C237.654 87.1276 237.654 87.3667 237.714 87.5461C237.654 87.4265 237.654 87.3667 237.654 87.2472Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.948 123.298C224.289 123.955 223.569 124.553 222.91 125.151C223.569 124.553 224.289 123.896 224.948 123.298Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.204 122.042L226.145 122.102C226.145 122.102 226.204 122.102 226.204 122.042Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.145 122.102C225.965 122.281 225.785 122.46 225.605 122.64C225.785 122.52 225.965 122.341 226.145 122.102Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.134 94.4814C238.134 94.8402 238.134 95.1989 238.074 95.4978C238.074 95.1989 238.074 94.8402 238.134 94.4814Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.073 95.7373C238.073 96.1558 238.013 96.5145 237.953 96.8732C238.013 96.5145 238.013 96.1558 238.073 95.7373Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.886 120.188C227.766 120.308 227.706 120.428 227.586 120.547C227.646 120.428 227.766 120.308 227.886 120.188Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.063 119.949C228.302 119.65 228.542 119.411 228.722 119.112C228.422 119.471 228.123 119.83 227.883 120.188C227.943 120.129 228.003 120.069 228.063 119.949Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.585 120.548C227.106 121.086 226.686 121.624 226.207 122.042C226.627 121.564 227.106 121.086 227.585 120.548Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.923 117.438L229.863 117.498C229.923 117.498 229.923 117.498 229.923 117.438Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.658 109.129C234.658 109.129 234.658 109.189 234.598 109.189C234.658 109.189 234.658 109.189 234.658 109.129Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.127 123.118C207.986 139.38 183.054 148.467 159.501 148.527C135.947 148.467 111.075 139.32 93.8748 123.118C88.5408 118.036 78.1125 103.688 81.5287 86.3506C89.9792 70.8664 109.637 73.0784 123.002 84.4973C124.92 86.1115 126.718 87.6659 128.516 89.1007C128.696 89.2203 140.682 98.3673 146.855 92.5084C154.766 85.0353 145.237 40.7349 129.235 28.2399C132.771 25.9681 136.547 24.0549 140.622 22.6201C146.915 35.9521 156.684 63.8716 157.104 88.0246C157.104 88.0844 157.104 88.1441 157.104 88.2637C157.104 95.9759 159.441 95.4977 159.441 95.4977C159.441 95.4977 161.778 95.9759 161.778 88.2637C161.778 88.2039 161.778 88.0844 161.778 88.0246C162.198 63.9313 171.967 35.9521 178.26 22.6201C182.335 24.0549 186.111 25.9681 189.647 28.2399C173.705 40.7349 164.116 85.0353 172.027 92.5084C178.2 98.3075 190.186 89.2203 190.366 89.1007C192.164 87.6061 193.962 86.1115 195.88 84.4973C209.245 73.0784 228.963 70.8664 237.353 86.3506C240.829 103.688 230.461 118.096 225.127 123.118Z",
    fill: "url(#paint10_radial_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.059 71.3447C242.026 93.1661 228.901 112.596 222.728 118.694C206.187 134.956 182.154 144.043 159.499 144.103C136.785 144.043 112.812 134.896 96.2704 118.694C90.0974 112.656 76.9722 93.2259 87.9398 71.3447C71.9978 94.9597 87.0408 116.662 93.9331 123.118C111.074 139.38 136.006 148.467 159.559 148.527C183.113 148.467 207.985 139.32 225.185 123.118C231.958 116.662 247.001 94.9597 231.059 71.3447Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.086 96.5736C172.086 100.878 164.175 106.199 159.5 106.199C154.466 106.199 146.914 100.818 146.914 96.5736C146.914 92.3289 156.084 91.0137 159.5 91.0137C162.916 91.0735 172.086 92.3289 172.086 96.5736Z",
    fill: "url(#paint11_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.498 95.0791C162.345 95.0791 164.652 94.6509 164.652 94.1226C164.652 93.5943 162.345 93.166 159.498 93.166C156.651 93.166 154.344 93.5943 154.344 94.1226C154.344 94.6509 156.651 95.0791 159.498 95.0791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.314 77.4426C136.438 77.4426 141.402 72.4908 141.402 66.3824C141.402 60.2741 136.438 55.3223 130.314 55.3223C124.191 55.3223 119.227 60.2741 119.227 66.3824C119.227 72.4908 124.191 77.4426 130.314 77.4426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.314 74.8124C134.981 74.8124 138.764 71.0383 138.764 66.3828C138.764 61.7272 134.981 57.9531 130.314 57.9531C125.647 57.9531 121.863 61.7272 121.863 66.3828C121.863 71.0383 125.647 74.8124 130.314 74.8124Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.628 66.2475C136.396 65.8602 136.305 64.1368 135.423 62.3984C134.542 60.6599 133.205 59.5646 132.437 59.952C131.669 60.3393 131.761 62.0626 132.642 63.8011C133.523 65.5395 134.86 66.6348 135.628 66.2475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.066 70.0887C136.728 70.0887 137.264 69.5533 137.264 68.893C137.264 68.2326 136.728 67.6973 136.066 67.6973C135.404 67.6973 134.867 68.2326 134.867 68.893C134.867 69.5533 135.404 70.0887 136.066 70.0887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.748 77.4426C194.871 77.4426 199.835 72.4908 199.835 66.3824C199.835 60.2741 194.871 55.3223 188.748 55.3223C182.624 55.3223 177.66 60.2741 177.66 66.3824C177.66 72.4908 182.624 77.4426 188.748 77.4426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.747 74.8124C193.414 74.8124 197.198 71.0383 197.198 66.3828C197.198 61.7272 193.414 57.9531 188.747 57.9531C184.08 57.9531 180.297 61.7272 180.297 66.3828C180.297 71.0383 184.08 74.8124 188.747 74.8124Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.058 66.2485C194.826 65.8611 194.734 64.1378 193.853 62.3994C192.972 60.6609 191.635 59.5656 190.867 59.953C190.099 60.3403 190.191 62.0636 191.072 63.8021C191.953 65.5405 193.29 66.6358 194.058 66.2485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.499 70.0887C195.161 70.0887 195.698 69.5533 195.698 68.893C195.698 68.2326 195.161 67.6973 194.499 67.6973C193.837 67.6973 193.301 68.2326 193.301 68.893C193.301 69.5533 193.837 70.0887 194.499 70.0887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.979 94.2425C219.54 94.2425 224.047 92.3956 224.047 90.1173C224.047 87.8391 219.54 85.9922 213.979 85.9922C208.418 85.9922 203.91 87.8391 203.91 90.1173C203.91 92.3956 208.418 94.2425 213.979 94.2425Z",
    fill: "#F2857C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.022 94.2425C110.583 94.2425 115.09 92.3956 115.09 90.1173C115.09 87.8391 110.583 85.9922 105.022 85.9922C99.461 85.9922 94.9531 87.8391 94.9531 90.1173C94.9531 92.3956 99.461 94.2425 105.022 94.2425Z",
    fill: "#F2857C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.499 134.837C152.727 134.837 148.172 130.951 148.172 125.152C148.172 118.934 153.206 111.461 159.499 111.461C165.732 111.461 170.826 118.934 170.826 125.152C170.826 130.951 166.271 134.837 159.499 134.837Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5 112.238C165.313 112.238 170.048 119.352 170.048 125.211C170.048 131.01 165.313 134.119 159.5 134.119C153.686 134.119 148.951 131.01 148.951 125.211C148.951 119.352 153.686 112.238 159.5 112.238ZM159.5 110.743C152.847 110.743 147.453 118.635 147.453 125.211C147.453 131.429 152.308 135.614 159.5 135.614C166.691 135.614 171.546 131.429 171.546 125.211C171.546 118.635 166.152 110.743 159.5 110.743Z",
    fill: "#B28560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.148 129.635C151.886 132.565 155.422 134.119 159.558 134.119C163.633 134.119 167.169 132.565 168.967 129.635C168.428 125.989 164.472 123.179 159.558 123.179C154.643 123.179 150.628 125.989 150.148 129.635Z",
    fill: "#F2A694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5 112.237C156.983 112.237 154.706 113.553 152.848 115.525L153.327 117.199C154.346 119.053 164.834 118.873 165.733 117.199L166.213 115.585C164.415 113.553 162.077 112.237 159.5 112.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.773 128.259L216.316 125.868C216.316 125.868 213.439 114.748 218.593 107.753C222.549 102.373 231.958 105.302 232.678 110.982C233.337 116.661 230.22 120.667 230.22 120.667L231.839 120.009C233.097 119.71 234.176 120.966 233.577 122.102C232.857 123.536 231.359 125.39 228.303 127.422C221.59 131.847 218.773 128.259 218.773 128.259Z",
    fill: "url(#paint12_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.223 142.847C192.402 146.553 193.062 150.559 194.14 154.804C194.86 157.733 195.759 160.782 196.778 163.951L214.278 166.462C219.852 167.239 224.886 163.114 225.245 157.554L227.103 128.678L227.163 128.259L225.905 127.96L224.346 127.661L216.375 125.987L214.757 135.732L212.779 147.928L192.942 142.727L192.223 142.847Z",
    fill: "url(#paint13_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.773 128.259L216.316 125.868C216.316 125.868 213.439 114.748 218.593 107.753C222.549 102.373 231.958 105.302 232.678 110.982C233.337 116.661 230.22 120.667 230.22 120.667L231.839 120.009C233.097 119.71 234.176 120.966 233.577 122.102C232.857 123.536 231.359 125.39 228.303 127.422C221.59 131.847 218.773 128.259 218.773 128.259Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.223 142.847C192.402 146.553 193.062 150.559 194.14 154.804C194.86 157.733 195.759 160.782 196.778 163.951L214.278 166.462C219.852 167.239 224.886 163.114 225.245 157.554L227.103 128.678L227.163 128.259L225.905 127.96L224.346 127.661L216.375 125.987L214.757 135.732L212.779 147.928L192.942 142.727L192.223 142.847Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M194.141 154.744C194.86 157.673 195.759 160.722 196.778 163.891L214.278 166.402C219.852 167.179 224.886 163.054 225.246 157.494L227.103 128.618L227.163 128.199C227.523 127.96 227.883 127.781 228.302 127.482C231.359 125.449 232.857 123.596 233.576 122.161C234.176 121.025 233.097 119.71 231.838 120.069L230.22 120.726C230.4 120.487 233.336 116.541 232.677 111.041C232.557 110.144 232.258 109.307 231.778 108.59C231.598 108.291 231.359 108.052 231.179 107.813C230.34 106.916 229.261 106.199 228.062 105.72C227.943 105.661 227.823 105.601 227.703 105.601C227.583 105.541 227.463 105.541 227.403 105.481C227.283 105.421 227.163 105.421 227.044 105.362C226.804 105.302 226.564 105.242 226.324 105.182C225.665 105.063 225.006 105.003 224.287 105.003C224.287 105.003 234.955 107.992 225.665 123.536C225.665 123.536 226.504 126.107 224.347 127.243C224.347 127.243 224.347 127.362 224.287 127.602C224.227 127.96 224.167 128.618 224.107 129.455C223.448 136.151 221.47 155.82 220.93 157.554C219.192 162.934 215.776 162.396 206.367 160.842C198.216 159.527 196.478 157.972 194.141 154.744Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.286 128.259L102.743 125.868C102.743 125.868 105.62 114.748 100.466 107.753C96.5104 102.373 87.101 105.302 86.3818 110.982C85.7225 116.661 88.839 120.667 88.839 120.667L87.2208 120.009C85.9622 119.71 84.8835 120.966 85.4828 122.102C86.202 123.536 87.7003 125.39 90.7568 127.422C97.4093 131.847 100.286 128.259 100.286 128.259Z",
    fill: "url(#paint14_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.775 142.847C126.595 146.554 125.936 150.559 124.857 154.804C124.138 157.733 123.239 160.782 122.22 163.951L104.72 166.462C99.1464 167.239 94.112 163.114 93.7524 157.554L91.9545 128.558L91.8945 128.14L93.1531 127.841L94.7114 127.542L102.682 125.868L104.301 135.613L106.278 147.809L126.116 142.608L126.775 142.847Z",
    fill: "url(#paint15_linear_197_177307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.286 128.259L102.743 125.868C102.743 125.868 105.62 114.748 100.466 107.753C96.5104 102.373 87.101 105.302 86.3818 110.982C85.7225 116.661 88.839 120.667 88.839 120.667L87.2208 120.009C85.9622 119.71 84.8835 120.966 85.4828 122.102C86.202 123.536 87.7003 125.39 90.7568 127.422C97.4093 131.847 100.286 128.259 100.286 128.259Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.775 142.847C126.595 146.554 125.936 150.559 124.857 154.804C124.138 157.733 123.239 160.782 122.22 163.951L104.72 166.462C99.1464 167.239 94.112 163.114 93.7524 157.554L91.9545 128.558L91.8945 128.14L93.1531 127.841L94.7114 127.542L102.682 125.868L104.301 135.613L106.278 147.809L126.116 142.608L126.775 142.847Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M124.858 154.744C124.139 157.673 123.24 160.722 122.221 163.891L104.721 166.402C99.1474 167.179 94.1131 163.054 93.7535 157.494L91.9555 128.558L91.8956 128.14C91.536 127.901 91.1764 127.721 90.7568 127.422C87.7003 125.39 86.202 123.536 85.4828 122.102C84.8835 120.966 85.9622 119.65 87.2208 120.009L88.839 120.667C88.6592 120.428 85.7225 116.482 86.3818 110.982C86.5016 110.085 86.8013 109.248 87.2808 108.53C87.4606 108.232 87.7003 107.992 87.8801 107.753C88.7191 106.856 89.7979 106.139 90.9966 105.661C91.1164 105.601 91.2363 105.541 91.3562 105.541C91.476 105.481 91.5959 105.481 91.6558 105.422C91.7757 105.362 91.8956 105.362 92.0154 105.302C92.2552 105.242 92.4949 105.182 92.7346 105.123C93.3939 105.003 94.0531 104.943 94.7723 104.943C94.7723 104.943 84.1043 107.933 93.3939 123.477C93.3939 123.477 92.5548 126.047 94.7124 127.183C94.7124 127.183 94.7124 127.303 94.7723 127.542C94.8322 127.901 94.8922 128.558 94.9521 129.395C95.6114 136.091 97.5891 155.76 98.1285 157.494C99.8666 162.875 103.283 162.337 112.692 160.782C120.843 159.527 122.521 157.972 124.858 154.744Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_177307",
    x1: 47.4949,
    y1: 196.27,
    x2: 105.088,
    y2: 203.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_177307",
    x1: 134.24,
    y1: 274.177,
    x2: 69.6544,
    y2: 139.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_177307",
    x1: 271.517,
    y1: 196.27,
    x2: 213.925,
    y2: 203.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_197_177307",
    x1: 184.774,
    y1: 274.177,
    x2: 249.359,
    y2: 139.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_197_177307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.673 142.551) rotate(90) scale(87.6381 40.0969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_197_177307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.93 15.1261) scale(36.223 36.1337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#615B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#5A5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8427,
    stopColor: "#4F494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9501,
    stopColor: "#3E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_197_177307",
    x1: 195.198,
    y1: 33.2608,
    x2: 226.323,
    y2: 34.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_197_177307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.119 15.1261) rotate(180) scale(36.223 36.1337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#615B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#5A5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8427,
    stopColor: "#4F494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9501,
    stopColor: "#3E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_197_177307",
    x1: 123.854,
    y1: 33.2608,
    x2: 92.7295,
    y2: 34.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_197_177307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.497 90.6343) rotate(-90) scale(69.3553 86.4565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363052,
    stopColor: "#352F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6595,
    stopColor: "#565053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635D5F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_197_177307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.228 55.7908) scale(94.108 93.876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F3DFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7208,
    stopColor: "#EFDAC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8569,
    stopColor: "#E9D0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#E1C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_197_177307",
    x1: 159.511,
    y1: 103.743,
    x2: 159.511,
    y2: 90.4084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_197_177307",
    x1: 185.051,
    y1: 135.328,
    x2: 220.835,
    y2: 135.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    stopColor: "#B5CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#B4C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#B2B6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    stopColor: "#B0A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#AD8AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#AA6CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA6CE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_197_177307",
    x1: 185.051,
    y1: 135.328,
    x2: 220.835,
    y2: 135.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    stopColor: "#B5CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#B4C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#B2B6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    stopColor: "#B0A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#AD8AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#AA6CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA6CE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_197_177307",
    x1: 133.964,
    y1: 135.328,
    x2: 98.18,
    y2: 135.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    stopColor: "#B5CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#B4C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#B2B6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    stopColor: "#B0A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#AD8AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#AA6CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA6CE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_197_177307",
    x1: 133.963,
    y1: 135.328,
    x2: 98.1789,
    y2: 135.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    stopColor: "#B5CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#B4C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#B2B6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    stopColor: "#B0A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#AD8AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#AA6CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA6CE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_177307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 311,
    fill: "white",
    transform: "translate(53 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarGliderAfraid);
export default __webpack_public_path__ + "static/media/sugarGlider_afraid.30f25a16fca6c7ca979c1d5f374f3663.svg";
export { ForwardRef as ReactComponent };